import React from 'react';
import {FormGroup, Label, Input} from 'reactstrap';

interface CylinderEditorProps {
    height: number;
    diameter: number;
    diameterTop?: number | null;
    diameterBottom?: number | null;
    tessellation?: number | null;
    onHeightChange: (height: number) => void;
    onDiameterChange: (diameter: number) => void;
    onDiameterTopChange: (diameterTop: number | null) => void;
    onDiameterBottomChange: (diameterBottom: number | null) => void;
    onTessellationChange: (tessellation: number | null) => void;
}

// The top and bottom diameters (for cones) fall back to the diameter when
// they're empty.
const CylinderEditor: React.FC<CylinderEditorProps> = ({
    height,
    diameter,
    diameterTop,
    diameterBottom,
    tessellation,
    onHeightChange,
    onDiameterChange,
    onDiameterTopChange,
    onDiameterBottomChange,
    onTessellationChange
}) => {
    const handleHeightChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = parseFloat(e.target.value);
        onHeightChange(isNaN(value) ? 0 : value);
    };

    const handleDiameterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = parseFloat(e.target.value);
        onDiameterChange(isNaN(value) ? 0 : value);
    };

    const handleDiameterTopChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const value = parseFloat(e.target.value);
        onDiameterTopChange(isNaN(value) ? null : value);
    };

    const handleDiameterBottomChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const value = parseFloat(e.target.value);
        onDiameterBottomChange(isNaN(value) ? null : value);
    };

    const handleTessellationChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const value = parseInt(e.target.value, 10);
        onTessellationChange(isNaN(value) ? null : value);
    };

    return (
        <>
            <FormGroup>
                <Label>Height:</Label>
                <Input
                    type="number"
                    step="0.1"
                    value={height}
                    onChange={handleHeightChange}
                />
            </FormGroup>
            <FormGroup>
                <Label>Diameter:</Label>
                <Input
                    type="number"
                    step="0.1"
                    value={diameter}
                    onChange={handleDiameterChange}
                />
            </FormGroup>
            <div className="d-flex gap-2">
                <FormGroup style={{flex: 1}}>
                    <Label>Top diameter:</Label>
                    <Input
                        type="number"
                        step="0.1"
                        min="0"
                        value={diameterTop ?? ''}
                        placeholder={String(diameter)}
                        onChange={handleDiameterTopChange}
                    />
                </FormGroup>
                <FormGroup style={{flex: 1}}>
                    <Label>Bottom diameter:</Label>
                    <Input
                        type="number"
                        step="0.1"
                        min="0"
                        value={diameterBottom ?? ''}
                        placeholder={String(diameter)}
                        onChange={handleDiameterBottomChange}
                    />
                </FormGroup>
            </div>
            <FormGroup>
                <Label>Sides (3 makes a prism):</Label>
                <Input
                    type="number"
                    step="1"
                    min="3"
                    value={tessellation ?? ''}
                    placeholder="24"
                    onChange={handleTessellationChange}
                />
            </FormGroup>
        </>
    );
};

export default CylinderEditor;
